import React from 'react'
import { ThemeToggle } from './ThemeToggle'

import { NavLink } from 'react-router-dom';

const HomeNav = (props) =>{
  return(
    <div className='w-1/2'>
      <div className='nav flex justify-evenly items-center text-xs min-[500px]:text-sm xl:text-2xl 2xl:text-3xl'>
            
        <NavLink to="/" className={({ isActive }) => isActive ? 'border-b-2 xl:border-b-4': 'border-b-0'}>
          Home
        </NavLink> 
      
        <NavLink to="/about" className={({ isActive }) => isActive ? 'border-b-2 xl:border-b-4': 'border-b-0'}>
          About
        </NavLink> 
      
        <ThemeToggle />
          
      </div>
    </div>
  )
}

export const Navbar = () => {
  return (
    <div className='fixed w-full h-auto flex items-center px-6 xl:px-20 2xl:px-40 py-4 2xl:py-6 z-50 mb-16 bg-stone-600 dark:bg-stone-800 text-white'>
        
      <div className='w-1/2 font-bold text-sm xl:text-3xl 2xl:text-4xl'>
        <NavLink to="/" >
          ALESSANDRO DAVID
        </NavLink> 
      </div>

      <HomeNav />
    

    </div>
  )
}
